/* eslint-disable react/prop-types */
import React from 'react';

import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { MainLayout } from '@confluence/main-layout';
import { ManagePagesLoader } from '@confluence/manage-pages/entry-points/ManagePagesLoader';
import { shouldShowMobileWeb } from '@confluence/mobile-detection';
import { Screen } from '@confluence/screen';
import { useBooleanFeatureFlag } from '@confluence/session-data';

import SpaceBase from '../../SpaceBase';

export const SpaceBulkToolsRoute = ({ name, params: { spaceKey } }) => {
	const isMobile = shouldShowMobileWeb();
	const isSpaceAliasFFEnabled = useBooleanFeatureFlag('confluence.frontend.space.alias');

	return (
		<Screen
			screenEvent={{ name: 'spaceBulkTools', id: spaceKey }}
			pageState={{ routeName: name, spaceKey }}
		>
			<MainLayout enableNavigation={!isMobile} navView={CONTAINER_HOME_ID} spaceKey={spaceKey}>
				{isSpaceAliasFFEnabled ? (
					<SpaceBase>
						<ManagePagesLoader spaceKey={spaceKey} />
					</SpaceBase>
				) : (
					<ManagePagesLoader spaceKey={spaceKey} />
				)}
			</MainLayout>
		</Screen>
	);
};
